import { render, staticRenderFns } from "./distributorChangeRecord.vue?vue&type=template&id=e54064d4&scoped=true"
import script from "./distributorChangeRecord.vue?vue&type=script&lang=ts"
export * from "./distributorChangeRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54064d4",
  null
  
)

export default component.exports